export const MAX_NETWORK_ITEMS = 50;
